module.exports = __webpack_public_path__ + "Lenovo_ThinkPad_T470p_icon.svg?bf980a2e49ec976f7f903cb4252698ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Lenovo_ThinkPad_T470p_icon.svg
// module id = 201
// module chunks = 0